import React from 'react';

import { H3, H5 } from '@repo/ui-kit/components/core/Typography';
import { themeClasses } from '@repo/ui-kit/css/utils';

import { FlexColumn, FlexRow } from 'styles/layouts';

import { CardContent, Background, Wrapper } from './styles';
import { TestimonialCardProps } from './types';
import { ReactComponent as YoutubeIcon } from './youtubeIcon.svg';

export const TestimonialCard: React.FC<TestimonialCardProps> = ({
  title,
  name,
  subscribersText,
  image,
}) => {
  return (
    <Wrapper>
      <Background backgroundImage={image.url}>
        <CardContent>
          <FlexColumn className={themeClasses.dark} gap="24px" padding="32px">
            <H3 color="default">“{title}“</H3>
            <FlexColumn gap="12px">
              <H5 color="default">{name}</H5>
              <FlexRow gap="10px">
                <YoutubeIcon height="19px" width="27px" />
                <H5 color="default">{subscribersText}</H5>
              </FlexRow>
            </FlexColumn>
          </FlexColumn>
        </CardContent>
      </Background>
    </Wrapper>
  );
};
